import React from 'react';
import { withChartLogic } from "./withChartLogic";

export const REPORT_CONFIG = {
    'targets': {
        title: "Full Year APP Targets",
        apiUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPTargetsSearch",
        excelUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPTargetsDetailExcel",
        isMultiSeries: false,
        pieValueKey: "Total",
        tableColumns: [
            { header: "Category Name", key: "Values" },
            { header: "Total Count", key: "Total", isNumeric: true }
        ]
    },
    'achieved': {
        title: "Full Year APP Achieved",
        apiUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPAchievementsSearch",
        excelUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPAchievementsDetailExcel",
        isMultiSeries: false,
        pieValueKey: "Total",
        tableColumns: [
            { header: "Category Name", key: "Values" },
            { header: "Total Count", key: "Total", isNumeric: true }
        ]
    },
    'variance': {
        title: "Full Year APP Variance",
        apiUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPVarianceSearch",
        excelUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPVarianceDetailExcel",
        isMultiSeries: true,
        pieValueKey: "Variance", 
        achievementKey: "AchievementTotal",
        targetKey: "TargetTotal",
        varianceKey: "Variance",
        tableColumns: [
            { header: "Category Name", key: "Values" },
            { header: "Target Amount", key: "TargetTotal", isNumeric: true },
            { header: "Actual Achievement", key: "AchievementTotal", isNumeric: true },
            { header: "Variance", key: "Variance", isVariance: true, isNumeric: true }
        ]
    },
    'performance': {
        title: "Annual Performance",
        apiUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPPerformanceSearch",
        excelUrl: "api/sims/APPSummaryDashboard/GetFullYearAPPPerformanceDetailExcel",
        isMultiSeries: true,
        pieValueKey: "Performance", 
        achievementKey: "AchievementTotal",
        targetKey: "TargetTotal",
        performanceKey: "Performance",
        tableColumns: [
            { header: "Category Name", key: "Values" },
            { header: "Target Amount", key: "TargetTotal", isNumeric: true },
            { header: "Actual Achievement", key: "AchievementTotal", isNumeric: true },
            { header: "Performance", key: "Performance", isPerformance: true, isNumeric: true }
        ]
    },
    'quarterlyperformance': {
        title: "Quarterly Performance",
        apiUrl: "api/sims/APPSummaryDashboard/GetQuarterAPPPerformanceSearch",
        excelUrl: "api/sims/APPSummaryDashboard/GetQuarterAPPPerformanceDetailExcel",
        isMultiSeries: true,
        hasQuarterFilter: true,
        pieValueKey: "Performance", 
        achievementKey: "AchievementTotal",
        targetKey: "TargetTotal",
        performanceKey: "Performance",
        tableColumns: [
            { header: "Category Name", key: "Values" },
            { header: "Target Amount", key: "TargetTotal", isNumeric: true },
            { header: "Actual Achievement", key: "AchievementTotal", isNumeric: true },
            { header: "Performance", key: "Performance", isPerformance: true, isNumeric: true }
        ]
    }
};

export const BarChart = withChartLogic(({ chartRef }) => <div ref={chartRef} />, 'column');
export const LineChart = withChartLogic(({ chartRef }) => <div ref={chartRef} />, 'line');
export const PieChart = withChartLogic(({ chartRef }) => <div ref={chartRef} />, 'pie');